import { render } from "./gybGetedDetail.vue?vue&type=template&id=c4725076"
import script from "./gybGetedDetail.vue?vue&type=script&lang=js"
export * from "./gybGetedDetail.vue?vue&type=script&lang=js"

import "./gybGetedDetail.vue?vue&type=style&index=0&id=c4725076&lang=scss"

import exportComponent from "/Users/wanggaochao/项目/善城 (2)/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__